import { Avatar, Box, Grid, Typography } from "@common-ui/ui";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import { ClientPlaceProfileImage } from "./ClientPlaceProfileImage";

export const PlaceProfile = ({ placeProfile }) => {
  return (
    <>
      {placeProfile === undefined || placeProfile === null ? (
        <NoPlaceLayout />
      ) : (
        <PlaceProfileLayout placeProfile={placeProfile} />
      )}
    </>
  );
};

const NoPlaceLayout = () => {
  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item>
        <Avatar
          variant="round"
          sx={{ height: 70, width: 70, bgcolor: "#d7eef9", color: "#4f97cd" }}
        >
          <LocationOnIcon />
        </Avatar>
      </Grid>
      <Grid item md={8} xs={8}>
        <Box sx={{ ml: 3, color: "#4f97cd" }}>
          <div>
            <Typography sx={{ mt: 1, position: "relative" }}>
              No Place has been selected.
            </Typography>
          </div>
          <div>
            <Typography>Add a place for this work event.</Typography>
          </div>
        </Box>
      </Grid>
    </Grid>
  );
};

const PlaceProfileLayout = ({ placeProfile }) => {
  const city =
    placeProfile?.address?.city !== "" ? placeProfile?.address?.city : "---";
  const stateOrProvince =
    placeProfile?.address?.state_or_province !== ""
      ? placeProfile?.address?.state_or_province
      : "---";
  const contactPerson =
    placeProfile?.contact_name !== "" ? placeProfile?.contact_name : "---";
  const contactEmail =
    placeProfile?.contact_email !== "" ? placeProfile?.contact_email : "---";
  const contactPhone =
    placeProfile?.contact_phone !== "" ? placeProfile?.contact_phone : "---";

  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item>
        <ClientPlaceProfileImage data={placeProfile} />
      </Grid>
      <Grid item md={8} xs={8}>
        <Grid
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="stretch"
        >
          <Grid sx={{ marginLeft: "1rem" }} item>
            <Typography
              sx={{ mt: 1, position: "relative" }}
              variant="h6"
              fontWeight="700"
            >
              {`${city}, ${stateOrProvince}`}
            </Typography>
            <Box>
              <Typography fontWeight="700" fontSize="0.7rem">
                <span
                  style={{
                    display: "inline-flex",
                    marginRight: 2,
                    color: "#2b7cd3",
                    marginTop: 2,
                  }}
                >
                  <ContactPageIcon
                    fontSize="small"
                    style={{ verticalAlign: "middle", marginRight: 5 }}
                    color="disabled"
                  />
                  {contactPerson}
                </span>
                <span
                  style={{
                    display: "inline-flex",
                    marginRight: 2,
                    color: "#2b7cd3",
                  }}
                >
                  <EmailIcon
                    fontSize="small"
                    style={{ verticalAlign: "middle", marginRight: 5 }}
                    color="disabled"
                  />
                  {contactEmail}
                </span>
                <span
                  style={{
                    display: "inline-flex",
                    marginRight: 2,
                    color: "#2b7cd3",
                  }}
                >
                  <PhoneIphoneIcon
                    fontSize="small"
                    style={{ verticalAlign: "middle", marginRight: 5 }}
                    color="disabled"
                  />
                  {contactPhone}
                </span>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
